"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assured_1 = __importDefault(require("../../assured"));
const insuranceCoverage_1 = __importDefault(require("../../insuranceCoverage/insuranceCoverage"));
const paymentMethod_1 = __importDefault(require("../../payments/paymentMethod"));
const shipmentContact_1 = __importDefault(require("../../shipmentContact"));
const shipment_1 = __importDefault(require("../../shipment"));
const user_1 = __importDefault(require("../../user"));
class InsureLoadPageData {
    constructor(partner, user, shipment, assured, shipmentContact, coverage, paymentMethod, insureLoadId, certificateNumber, emailAssured, status, isEditable, authorizedUsers) {
        this.partner = partner;
        this.user = user;
        this.shipment = shipment;
        this.assured = assured;
        this.shipmentContact = shipmentContact;
        this.coverage = coverage;
        this.paymentMethod = paymentMethod;
        this.insureLoadId = insureLoadId;
        this.certificateNumber = certificateNumber;
        this.emailAssured = emailAssured;
        this.status = status;
        this.isEditable = isEditable;
        this.authorizedUsers = authorizedUsers;
    }
    static fromObj(data) {
        return new InsureLoadPageData(data.partner, user_1.default.fromObj(data.user), shipment_1.default.fromObj(data.shipment), assured_1.default.fromObj(data.assured), shipmentContact_1.default.fromObj(data.shipmentContact), data.coverage ? insuranceCoverage_1.default.fromObj(data.coverage) : undefined, data.paymentMethod
            ? paymentMethod_1.default.fromObj(data.paymentMethod)
            : undefined, data.insureLoadId, data.certificateNumber, data.emailAssured, data.status, data.isEditable, data.authorizedUsers);
    }
}
exports.default = InsureLoadPageData;
//# sourceMappingURL=insureLoadPageData.class.js.map